export const CREATE_MSTEAMS_CHANNEL = "CREATE_MSTEAMS_CHANNEL";
export const CREATE_MSTEAMS_CHANNEL_SUCCESS = "CREATE_MSTEAMS_CHANNEL_SUCCESS";
export const CREATE_MSTEAMS_CHANNEL_FAIL = "CREATE_MSTEAMS_CHANNEL_FAIL";
export const GET_MSTEAMS_CHANNELS = "GET_MSTEAMS_CHANNELS";
export const GET_MSTEAMS_CHANNELS_SUCCESS = "GET_MSTEAMS_CHANNELS_SUCCESS";
export const GET_MSTEAMS_CHANNELS_FAIL = "GET_MSTEAMS_CHANNELS_FAIL";
export const DELETE_MSTEAMS_CHANNEL = "DELETE_MSTEAMS_CHANNEL";
export const DELETE_MSTEAMS_CHANNEL_SUCCESS = "DELETE_MSTEAMS_CHANNEL_SUCCESS";
export const DELETE_MSTEAMS_CHANNEL_FAIL = "DELETE_MSTEAMS_CHANNEL_FAIL";
